import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=7b5ec054&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"
import style0 from "./Select2.vue?vue&type=style&index=0&id=7b5ec054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ec054",
  null
  
)

export default component.exports